import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRouteStore } from '@/store/route';

const SITE_TITLE = 'Sakura Floors';

const RouteBeforeEach = ({ route: routeInfo }) => {
  const location = useLocation();
  const { setCurrentRoute } = useRouteStore();

  useEffect(() => {
    setCurrentRoute(location);
    document.title = [routeInfo.i18nTitle, SITE_TITLE].filter(Boolean).join(' · ');
    window.scrollTo(0, 0);
  }, [location.pathname, routeInfo.i18nTitle, setCurrentRoute]);

  return routeInfo.component || null;
};

export default RouteBeforeEach;
